export default __webpack_public_path__ + "static/cross-lines-7bbcbe052e64078fabf0c2f833d78ddc.png";